// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4121f8b2","703":"a42c53ad","787":"bc346269"}[chunkId] + ".chunk.js";
};